import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import DesiredPartner from './components/DesiredPartner';
import { useDispatch, useSelector } from 'react-redux';
import {
  countryCodes,
  stateCodes,
  citieslist,
  familyStatus,
  familyValue,
  familyType,
  education_list,
  currencyCodes,
  get_byID
} from './redux/slice';
import { pageview } from '../../utilities/gtag';

const index = () => {
  useEffect(() => {
    document.title = 'Partner preferences - Describe your ideal match';
  }, []);
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  const dispatch = useDispatch();
  const { country_codes, education_details } = useSelector(
    (state) => state.editprofile
  );
  const { state_details, city_details } = useSelector(
    (state) => state.edithoroscope
  );

  const { currency_data } = useSelector((state) => state.editpartner);

  const {
    // Occupation_Data,
    family_Status,
    family_Value,
    family_Type
  } = useSelector((state) => state.editprofile);
  const { user_data } = useSelector((state) => state.listDashboard);

  // console.log('user_data', user_data);

  useEffect(() => {
    get_countryCodes();
    get_states();
    get_cities();
    get_familyStatus();
    get_familyValue();
    get_familyType();
    get_education_details();
    get_currency();
    get_listby_id();
  }, []);

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userId = matUserObject.user_details.id;

  const get_listby_id = () => {
    const payload = userId;
    dispatch(get_byID(payload));
  };

  const get_countryCodes = () => {
    dispatch(countryCodes());
  };

  const get_currency = () => {
    dispatch(currencyCodes());
  };

  const get_states = () => {
    dispatch(stateCodes());
  };

  const get_cities = () => {
    dispatch(citieslist());
  };

  const get_familyStatus = () => {
    dispatch(familyStatus());
  };
  const get_familyValue = () => {
    dispatch(familyValue());
  };
  const get_familyType = () => {
    dispatch(familyType());
  };
  const get_education_details = () => {
    dispatch(education_list());
  };
  return (
    <>
      <Layout sider={true}>
        <DesiredPartner
          country_codes={country_codes}
          state_details={state_details}
          city_details={city_details}
          family_Status={family_Status}
          family_Value={family_Value}
          family_Type={family_Type}
          education_list={education_details}
          currency_data={currency_data}
          user_data={user_data}
        />
      </Layout>
    </>
  );
};

export default index;
